import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/auth/ProtectedRoute'
import LoginForm from './components/auth/LoginForm'
import { Layout } from './components/layout/Layout'
import { ErrorBoundary } from './components/ui/ErrorBoundary'
import DashboardPage from './pages/DashboardPage'
import NewsSignalsPage from './pages/NewsSignalsPage'
import ReportsPage from './pages/ReportsPage'
import LogsPage from './pages/LogsPage'
import PromptsPage from './pages/PromptsPage'
import ScraperPage from './pages/ScraperPage'
import ScraperV2Page from './pages/ScraperV2Page'

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
    },
  },
})



const AppContent: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ProtectedRoute fallback={<LoginForm />}>
          <BrowserRouter>
            <Routes>
              {/* Redirect root to dashboard */}
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              
              {/* Main layout with sidebar and routes */}
              <Route path="/" element={<Layout />}>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="news-signals" element={<NewsSignalsPage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="logs" element={<LogsPage />} />
                <Route path="prompts" element={<PromptsPage />} />
                <Route path="scraper" element={<ScraperPage />} />
                <Route path="scraper-v2" element={<ScraperV2Page />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ProtectedRoute>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
    </QueryClientProvider>
  )
}
